import React from 'react';

// const tableData = [
//   {
//     area: 'Process Automation',
//     evolution:
//       'XAI Identifies Bottlenecks And Automates Repetitive Operational Workflows',
//     functionality: 'Workflow Analysis, Task Automation, Process Optimization',
//     useCase:
//       'Automate Data Entry, Streamline Approvals, Optimize Workflows – Significant Reduction In Manual Tasks With Fewer Errors',
//     tools: 'Zapier AI, UiPath, Process Street AI',
//   },
//   {
//     area: 'Data Analysis',
//     evolution:
//       'AI Delivers Real-Time Operational Insights And Predictive Analytics',
//     functionality: 'Dashboard Creation, Trend Analysis, Forecasting',
//     useCase:
//       'Monitor KPIs, Predict Bottlenecks, Optimize Resource Allocation – Faster Insights With Proactive Problem-Solving',
//     tools: 'Tableau AI, Power BI With AI, DataRobot',
//   },
//   {
//     area: 'Resource Planning',
//     evolution:
//       'AI-Powered Forecasting Optimizes Capacity Planning And Scheduling',
//     functionality:
//       'Demand Forecasting, Resource Allocation, Schedule Optimization',
//     useCase:
//       'Plan Staffing Needs, Allocate Resources, Optimize Schedules – Better Resource Utilization With Reduced Overtime',
//     tools: 'Monday.com AI, Clockwise AI, Forecast',
//   },
//   {
//     area: 'Quality Management',
//     evolution: 'AI Automates Quality Checks And Ensures Compliance Monitoring',
//     functionality: 'Audit Automation, Compliance Tracking, Issue Detection',
//     useCase:
//       'Monitor Quality Standards, Ensure Compliance, Identify Improvement Areas – Faster Audits With Proactive Compliance',
//     tools: 'Qualio AI, MasterControl, SafetyCulture AI',
//   },
//   {
//     area: 'Communication & Reporting',
//     evolution: 'AI Automates Report Generation And Stakeholder Communications',
//     functionality: 'Report Generation, Meeting Summaries, Status Updates',
//     useCase:
//       'Create Operational Reports, Summarize Meetings, Update Stakeholders – Less Time On Reporting With Better Transparency',
//     tools: 'Notion AI For Reports, ChatGPT For Summaries, Slack AI',
//   },
//   {
//     area: 'Vendor Management',
//     evolution:
//       'AI Assists In Vendor Evaluation And Automates Relationship Management',
//     functionality: 'Vendor Analysis, Contract Management, Performance Tracking',
//     useCase:
//       'Evaluate Suppliers, Manage Contracts, Track Vendor Performance – Better Vendor Decisions With Faster Procurement',
//     tools: 'Coupa AI, Ariba Intelligence, ChatGPT For Analysis',
//   },
// ];

const tableDataBySlug = {
  entrepreneurs: [
    {
      area: 'Process Automation',
      evolution:
        'XAI Identifies Bottlenecks And Automates Repetitive Operational Workflows',
      functionality: 'Workflow Analysis, Task Automation, Process Optimization',
      useCase:
        'Automate Data Entry, Streamline Approvals, Optimize Workflows – Significant Reduction In Manual Tasks With Fewer Errors',
      tools: 'Zapier AI, UiPath, Process Street AI',
    },
    {
      area: 'Data Analysis',
      evolution:
        'AI Delivers Real-Time Operational Insights And Predictive Analytics',
      functionality: 'Dashboard Creation, Trend Analysis, Forecasting',
      useCase:
        'Monitor KPIs, Predict Bottlenecks, Optimize Resource Allocation – Faster Insights With Proactive Problem-Solving',
      tools: 'Tableau AI, Power BI With AI, DataRobot',
    },
    {
      area: 'Resource Planning',
      evolution:
        'AI-Powered Forecasting Optimizes Capacity Planning And Scheduling',
      functionality:
        'Demand Forecasting, Resource Allocation, Schedule Optimization',
      useCase:
        'Plan Staffing Needs, Allocate Resources, Optimize Schedules – Better Resource Utilization With Reduced Overtime',
      tools: 'Monday.com AI, Clockwise AI, Forecast',
    },
    {
      area: 'Quality Management',
      evolution:
        'AI Automates Quality Checks And Ensures Compliance Monitoring',
      functionality: 'Audit Automation, Compliance Tracking, Issue Detection',
      useCase:
        'Monitor Quality Standards, Ensure Compliance, Identify Improvement Areas – Faster Audits With Proactive Compliance',
      tools: 'Qualio AI, MasterControl, SafetyCulture AI',
    },
    {
      area: 'Communication & Reporting',
      evolution:
        'AI Automates Report Generation And Stakeholder Communications',
      functionality: 'Report Generation, Meeting Summaries, Status Updates',
      useCase:
        'Create Operational Reports, Summarize Meetings, Update Stakeholders – Less Time On Reporting With Better Transparency',
      tools: 'Notion AI For Reports, ChatGPT For Summaries, Slack AI',
    },
    {
      area: 'Vendor Management',
      evolution:
        'AI Assists In Vendor Evaluation And Automates Relationship Management',
      functionality:
        'Vendor Analysis, Contract Management, Performance Tracking',
      useCase:
        'Evaluate Suppliers, Manage Contracts, Track Vendor Performance – Better Vendor Decisions With Faster Procurement',
      tools: 'Coupa AI, Ariba Intelligence, ChatGPT For Analysis',
    },
  ],
  'product-marketing-management': [
    {
      area: 'User & Market Research',
      evolution:
        'AI automates large-scale user research and competitive market scanning.',
      functionality:
        'Sentiment analysis, persona creation, trend detection, feedback clustering',
      useCase:
        'Understand customer needs, track competitors, prioritize problems – faster product-market fit',
      tools:
        'Otter.ai, Perplexity, MonkeyLearn, Dovetail, Brandwatch, Similarweb AI',
    },
    {
      area: 'Product Ideation & Validation',
      evolution:
        'AI enables rapid concept testing and user feedback on prototypes.',
      functionality:
        'Rapid prototyping, A/B testing, survey generation, feature scoring',
      useCase:
        'Validate ideas quickly, test usability, prioritize roadmap – reduced risk of building the wrong thing',
      tools: 'Maze AI, Figma AI, Bubble, Webflow AI, Typeform AI',
    },
    {
      area: 'Product Roadmapping',
      evolution:
        'AI generates and updates product roadmaps based on real-time data.',
      functionality:
        'Roadmap generation, impact estimation, feature clustering, release planning',
      useCase:
        'Plan sprints, align teams, adapt quickly – improved team agility',
      tools:
        'Airtable AI, Notion AI, Productboard AI, ChatGPT for feature briefs',
    },
    {
      area: 'Go-to-Market Strategy',
      evolution:
        'AI supports GTM strategy development and launch execution across channels.',
      functionality:
        'Messaging generation, asset creation, channel planning, launch playbooks',
      useCase:
        'Create tailored launch campaigns, align teams, track performance – faster, more coordinated launches',
      tools: 'Jasper, Copy.ai, Canva AI, RunwayML, Google Ads AI',
    },
    {
      area: 'Customer Feedback Loops',
      evolution:
        'AI systems monitor user feedback and continuously inform product iteration.',
      functionality:
        'NPS analysis, churn prediction, user segmentation, usage behavior clustering',
      useCase:
        'Optimize onboarding, reduce churn, improve satisfaction – higher retention and growth',
      tools: 'Mixpanel AI, Amplitude AI, Qualtrics AI, Hotjar AI',
    },
  ],
  marketing: [
    {
      area: 'Content Creation',
      evolution:
        'AI generates marketing content at scale with brand voice consistency.',
      functionality:
        'Copywriting, image/video generation, brand tone modeling, content repurposing',
      useCase:
        'Produce blog posts, ads, emails, social content – faster production, improved engagement',
      tools: 'Jasper, Copy.ai, Canva AI, Pictory, RunwayML',
    },
    {
      area: 'Audience Intelligence',
      evolution:
        'AI analyzes customer behavior and segments audiences automatically.',
      functionality:
        'Segmentation, persona generation, LTV modeling, behavioral clustering',
      useCase:
        'Target high-value users, personalize messaging, reduce churn – better ROAS',
      tools: 'Google Ads AI, Facebook Ads AI, Segment, HubSpot AI',
    },
    {
      area: 'Campaign Optimization',
      evolution:
        'AI optimizes campaign performance in real-time based on outcomes.',
      functionality:
        'A/B testing, budget reallocation, creative testing, channel optimization',
      useCase:
        'Increase conversions, lower CAC, maximize spend efficiency – improved ROI',
      tools: 'AdCreative.ai, Smartly.io, Madgicx, Optimizely',
    },
    {
      area: 'Brand Monitoring & Competitive Intelligence',
      evolution:
        'AI tools track brand perception and analyze competitors automatically.',
      functionality:
        'Sentiment analysis, share of voice, competitor tracking, trend alerts',
      useCase:
        'Respond to trends, benchmark performance, adapt strategy – more proactive marketing',
      tools: 'Brandwatch AI, Crayon, Sprinklr AI, Similarweb',
    },
    {
      area: 'Marketing Analytics & Reporting',
      evolution:
        'AI automates reporting and generates insights from marketing data.',
      functionality:
        'Dashboard creation, predictive analytics, ROI tracking, report generation',
      useCase:
        'Track KPIs, visualize results, forecast outcomes – faster insight, better decisions',
      tools: 'Tableau AI, Power BI, Looker AI, ChatGPT for reporting',
    },
  ],
  consulting: [
    {
      area: 'Research & Market Intelligence',
      evolution:
        'AI accelerates client research with real-time data gathering and synthesis.',
      functionality:
        'Industry monitoring, trend analysis, competitor benchmarking, insight generation',
      useCase:
        'Produce faster client deliverables, identify market shifts – improve strategic recommendations',
      tools: 'Perplexity, Crayon, Similarweb, AlphaSense AI',
    },
    {
      area: 'Strategic Framework Development',
      evolution:
        'AI helps develop and customize strategic models using client-specific data.',
      functionality:
        'SWOT/TOWS automation, scenario modeling, recommendation generation',
      useCase:
        'Build custom strategies, test outcomes – enhance quality of client insights',
      tools:
        'ChatGPT, Notion AI, strategic modeling tools, Figma AI for visuals',
    },
    {
      area: 'Client Intelligence & Personalization',
      evolution:
        'AI tracks client contexts and needs for more proactive engagement.',
      functionality:
        'Client monitoring, industry news integration, personalization triggers',
      useCase:
        'Anticipate client needs, surface relevant opportunities – increase client satisfaction and retention',
      tools: 'Apollo AI, Clay, LinkedIn AI tools, Zapier alerts',
    },
    {
      area: 'Presentation & Communication',
      evolution:
        'AI enhances visual storytelling and simplifies complex analysis.',
      functionality:
        'Slide generation, executive summary writing, visual design assistants',
      useCase:
        'Produce faster, clearer reports – better communication of insights to stakeholders',
      tools: 'Gamma AI, Tome, Beautiful.ai, Canva AI',
    },
    {
      area: 'Proposal & Scope Generation',
      evolution:
        'AI drafts proposals and statements of work tailored to client needs.',
      functionality:
        'RFP analysis, proposal drafting, scope outlining, pricing calculators',
      useCase:
        'Respond faster to opportunities, ensure accurate scoping – win more business with less effort',
      tools: 'ChatGPT, Notion AI templates, proposal automation tools',
    },
  ],
  'design-ui-ux': [
    {
      area: 'User Research & Insight Extraction',
      evolution:
        'AI automates research analysis and surfaces actionable user insights.',
      functionality:
        'Interview transcription, feedback clustering, sentiment detection, behavior patterning',
      useCase:
        'Identify user needs faster, reduce manual research – improve design decisions',
      tools: 'Otter.ai, Hotjar AI, Maze AI, UserTesting AI',
    },
    {
      area: 'Design Ideation & Concept Generation',
      evolution:
        'AI assists with creative ideation and provides intelligent design suggestions.',
      functionality:
        'Concept generation, prompt-driven wireframing, creative exploration',
      useCase:
        'Accelerate early-stage design, unlock new visual directions – increase creative output',
      tools: 'Midjourney, Figma AI, Adobe Firefly',
    },
    {
      area: 'Rapid Prototyping & Variants',
      evolution:
        'AI generates multiple design variants and automates prototyping workflows.',
      functionality:
        'Component generation, A/B test versioning, auto-prototype linking',
      useCase:
        'Create, test, and iterate designs faster – enhance design speed and experimentation',
      tools: 'Figma AI, Webflow AI, Uizard',
    },
    {
      area: 'Accessibility & Compliance',
      evolution:
        'AI reviews designs for accessibility and suggests improvements.',
      functionality: 'Contrast checking, alt text generation, WCAG scoring',
      useCase:
        'Ensure accessible experiences, meet compliance needs – reduce legal and user risk',
      tools: 'Stark AI, Axe AI, Figma plugins',
    },
    {
      area: 'Design Documentation & Handoff',
      evolution:
        'AI creates design documentation and ensures consistent developer handoff.',
      functionality:
        'Design system generation, spec extraction, developer notes automation',
      useCase:
        'Streamline handoff, improve implementation accuracy – reduce dev-designer friction',
      tools: 'Zeroheight AI, Figma Dev Mode, Relay AI',
    },
  ],
  operations: [
    {
      area: 'Process Automation',
      evolution:
        'XAI identifies bottlenecks and automates repetitive operational workflows',
      functionality: 'Workflow analysis, task automation, process optimization',
      useCase:
        'Automate data entry, streamline approvals, optimize workflows – significant reduction in manual tasks with fewer errors',
      tools: 'Zapier AI, UiPath, Process Street AI',
    },
    {
      area: 'Data Analysis',
      evolution:
        'AI delivers real-time operational insights and predictive analytics',
      functionality: 'Dashboard creation, trend analysis, forecasting',
      useCase:
        'Monitor KPIs, predict bottlenecks, optimize resource allocation – faster insights with proactive problem-solving',
      tools: 'Tableau AI, Power BI with AI, DataRobot',
    },
    {
      area: 'Resource Planning',
      evolution:
        'AI-powered forecasting optimizes capacity planning and scheduling',
      functionality:
        'Demand forecasting, resource allocation, schedule optimization',
      useCase:
        'Plan staffing needs, allocate resources, optimize schedules – better resource utilization with reduced overtime',
      tools: 'Monday.com AI, Clockwise AI, Forecast',
    },
    {
      area: 'Quality Management',
      evolution:
        'AI automates quality checks and ensures compliance monitoring',
      functionality: 'Audit automation, compliance tracking, issue detection',
      useCase:
        'Monitor quality standards, ensure compliance, identify improvement areas – faster audits with proactive compliance',
      tools: 'Qualio AI, MasterControl, SafetyCulture AI',
    },
    {
      area: 'Communication & Reporting',
      evolution:
        'AI automates report generation and stakeholder communications',
      functionality: 'Report generation, meeting summaries, status updates',
      useCase:
        'Create operational reports, summarize meetings, update stakeholders – less time on reporting with better transparency',
      tools: 'Notion AI for reports, ChatGPT for summaries, Slack AI',
    },
    {
      area: 'Vendor Management',
      evolution:
        'AI assists in vendor evaluation and automates relationship management',
      functionality:
        'Vendor analysis, contract management, performance tracking',
      useCase:
        'Evaluate suppliers, manage contracts, track vendor performance – better vendor decisions with faster procurement',
      tools: 'Coupa AI, Ariba Intelligence, ChatGPT for analysis',
    },
  ],
};

const AIAdaptabilityTable = ({ slug }) => {
  const tableData = tableDataBySlug?.[slug];

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[1000px] table-auto border-collapse border border-gray-200 text-left text-sm">
        <thead className="bg-[#00C29D] text-black">
          <tr className="bg-[#2DF8C5]">
            <th className="border border-gray-200 px-4 py-2 font-semibold">
              Area
            </th>
            <th className="border border-gray-200 px-4 py-2 font-semibold">
              Evolution
            </th>
            <th className="border border-gray-200 px-4 py-2 font-semibold">
              Functionality
            </th>
            <th className="border border-gray-200 px-4 py-2 font-semibold">
              Use-Case & Impact
            </th>
            <th className="border border-gray-200 px-4 py-2 font-semibold">
              Tools
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, idx) => (
            <tr key={idx} className="odd:bg-white even:bg-[#F2FBF7]">
              <td className="border border-gray-200 px-4 py-3 font-medium">
                {row.area}
              </td>
              <td className="border border-gray-200 px-4 py-3">
                {row.evolution}
              </td>
              <td className="border border-gray-200 px-4 py-3">
                {row.functionality}
              </td>
              <td className="border border-gray-200 px-4 py-3">
                {row.useCase}
              </td>
              <td className="border border-gray-200 px-4 py-3">{row.tools}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AIAdaptabilityTable;
